export const smartDocStaticParamType_Template = 'template';
//# sourceMappingURL=types.js.map